import dhtmlXGridObject from './dhtmlXGridObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import dhtmlxArray from './dhtmlxArray';
import goingValidation from '../../global/goingValidationClass';
import goingEvent from '../../global/goingEvent';


dhtmlXGridObject.prototype._CreateSelection = function (a, e) {
    if (this._selectionObj == null) {
        var c = document.createElement("div");
        c.style.position = "absolute";
        c.style.display = "none";
        c.className = "dhtmlxGrid_selection";
        this._selectionObj = c;
        this._selectionObj.onmousedown = function (g) {
            g = g || event;
            if (g.button == 2 || (dhx4.isMacOS && g.ctrlKey)) {
                return this.parentNode.grid.callEvent("onBlockRightClick", [
                    "BLOCK",
                    g
                ]);
            }
        };
        this._selectionObj.oncontextmenu = function (g) {
            (g || event).cancelBubble = true;
            return false;
        };
        this.objBox.appendChild(this._selectionObj);
    }
    this._selectionObj.style.width = "0px";
    this._selectionObj.style.height = "0px";
    this._selectionObj.style.left = a + "px";
    this._selectionObj.style.top = e + "px";
    this._selectionObj.startX = a;
    this._selectionObj.startY = e;
};
dhtmlXGridObject.prototype._ShowSelection = function () {
    if (this._selectionObj) {
        this._selectionObj.style.display = "";
    }
};
dhtmlXGridObject.prototype._HideSelection = function () {
    if (this._selectionObj) {
        this._selectionObj.style.display = "none";
    }
    this._selectionArea = null;
    if (this._clip_area) {
        this._clip_area.value = "";
        this._clip_area.blur();
    }
};
dhtmlXGridObject.prototype.copyBlockToClipboard = function () {
    if (!this._clip_area) {
        return;
    }
    if (this._selectionArea != null) {
        var e = new Array();
        if (this._mathSerialization) {
            this._agetm = "getMathValue";
        }
        else {
            if (this._strictText) {
                this._agetm = "getTitle";
            }
            else {
                this._agetm = "getValue";
            }
        }
        this._serialize_visible = true;
        for (var a = this._selectionArea.LeftTopRow; a <= this._selectionArea.RightBottomRow; a++) {
            var c = this._serializeRowToCVS(this.rowsBuffer[a], null, this._selectionArea.LeftTopCol, this._selectionArea.RightBottomCol + 1);
            if (!this._csvAID) {
                e[e.length] = c.substr(c.indexOf(this.csv.cell) + 1);
            }
            else {
                e[e.length] = c;
            }
        }
        e = e.join(this._CSVRowDelimiter);
        this._clip_area.value = e;
        this._clip_area.select();
        this._serialize_visible = false;
    }
};
dhtmlXGridObject.prototype.pasteBlockFromClipboard = function () {
    if (!this._clip_area) {
        return;
    }
    this._clip_area.select();
    var a = this;
    window.setTimeout(function () {
        a._pasteBlockFromClipboard();
        a = null;
    }, 1);
};
dhtmlXGridObject.prototype._pasteBlockFromClipboard = function () {
    var m = this._clip_area.value;
    if (!m) {
        return;
    }
    var w, a = null;
    if (this._selectionArea != null) {
        w = this._selectionArea.LeftTopRow;
        a = this._selectionArea.LeftTopCol;
    }
    else {
        if (this.cell != null && !this.editor) {
            w = this.getRowIndex(this.cell.parentNode.idd);
            a = this.cell._cellIndex;
        }
        else {
            return false;
        }
    }
    m = this.csvParser.unblock(m, this.csv.cell, this.csv.row);
    var o = w + m.length;
    var u = a + m[0].length;
    if (u > this._cCount) {
        u = this._cCount;
    }
    var g = 0;
    for (var r = w; r < o; r++) {
        var x = this.render_row(r);
        if (x == -1) {
            continue;
        }
        var e = 0;
        for (var h = a; h < u; h++) {
            if (this._hrrar[h] && !this._fake) {
                u = Math.min(u + 1, this._cCount);
                continue;
            }
            var s = this.cells3(x, h);
            if (s.isDisabled()) {
                e++;
                continue;
            }
            if (this._onEditUndoRedo) {
                this._onEditUndoRedo(2, x.idd, h, m[g][e], s.getValue());
            }
            if (s.combo) {
                var v = s.combo.values;
                for (var c = 0; c < v.length; c++) {
                    if (m[g][e] == v[c]) {
                        s.setValue(s.combo.keys[c]);
                        v = null;
                        break;
                    }
                }
                if (v != null && s.editable) {
                    s.setValue(m[g][e++]);
                }
                else {
                    e++;
                }
            }
            else {
                s[s.setImage ? "setLabel" : "setValue"](m[g][e++]);
            }
            s.cell.wasChanged = true;
        }
        this.callEvent("onRowPaste", [x.idd]);
        g++;
    }
};
dhtmlXGridObject.prototype.getSelectedBlock = function () {
    if (this._selectionArea) {
        return this._selectionArea;
    }
    else {
        if (this.getSelectedRowId() !== null) {
            return {
                LeftTopRow: this.getSelectedRowId(),
                LeftTopCol: this.getSelectedCellIndex(),
                RightBottomRow: this.getSelectedRowId(),
                RightBottomCol: this.getSelectedCellIndex()
            };
        }
        else {
            return null;
        }
    }
};
dhtmlXGridObject.prototype.enableSmartRendering = function (e, c, a) {
    if (arguments.length > 2) {
        if (c && !this.rowsBuffer[c - 1]) {
            this.rowsBuffer[c - 1] = 0;
        }
        c = a;
    }
    this._srnd = dhx4.s2b(e);
    this._srdh = this._srdh || 20;
    this._dpref = c || 0;
};
dhtmlXGridObject.prototype.enablePreRendering = function (a) {
    this._srnd_pr = parseInt(a || 50);
};
dhtmlXGridObject.prototype.forceFullLoading = function (a, h) {
    for (var e = 0; e < this.rowsBuffer.length; e++) {
        if (!this.rowsBuffer[e]) {
            var g = a || this.rowsBuffer.length - e;
            if (this.callEvent("onDynXLS", [e, g])) {
                var c = this;
                this.load(this.xmlFileUrl +
                    dhtmlx.url(this.xmlFileUrl) +
                    "posStart=" +
                    e +
                    "&count=" +
                    g, function () {
                    window.setTimeout(function () {
                        c.forceFullLoading(a, h);
                    }, 100);
                }, this._data_type);
            }
            return;
        }
    }
    if (h) {
        h.call(this);
    }
};
dhtmlXGridObject.prototype.setAwaitedRowHeight = function (a) {
    this._srdh = parseInt(a);
};
dhtmlXGridObject.prototype._get_view_size = function () {
    return Math.floor(parseInt(this.entBox.offsetHeight) / this._srdh) + 2;
};
dhtmlXGridObject.prototype._add_filler = function (m, a, c, g) {
    if (!a) {
        return null;
    }
    var l = "__filler__";
    var h = this._prepareRow(l);
    h.firstChild.style.width = "1px";
    h.firstChild.style.borderWidth = h.firstChild.style.padding = h.firstChild.style.margin =
        "0px";
    for (var e = 1; e < h.childNodes.length; e++) {
        h.childNodes[e].style.display = "none";
    }
    h.firstChild.style.height = a * this._srdh + "px";
    c = c || this.rowsCol[m];
    if (c && c.nextSibling) {
        c.parentNode.insertBefore(h, c.nextSibling);
    }
    else {
        if (window._isKHTML) {
            this.obj.appendChild(h);
        }
        else {
            this.obj.rows[0].parentNode.appendChild(h);
        }
    }
    this.callEvent("onAddFiller", [m, a, h, c, g]);
    return [m, a, h];
};
dhtmlXGridObject.prototype._update_srnd_view = function () {
    var l = Math.floor(this.objBox.scrollTop / this._srdh);
    var c = l + this._get_view_size();
    if (this.multiLine) {
        var m = this.objBox.scrollTop;
        l = 0;
        while (m > 0) {
            m -= this.rowsCol[l] ? this.rowsCol[l].offsetHeight : this._srdh;
            l++;
        }
        c = l + this._get_view_size();
        if (l > 0) {
            l--;
        }
    }
    c += this._srnd_pr || 0;
    if (c > this.rowsBuffer.length) {
        c = this.rowsBuffer.length;
    }
    for (var g = l; g < c; g++) {
        if (!this.rowsCol[g]) {
            var h = this._add_from_buffer(g);
            if (h == -1) {
                if (this.xmlFileUrl) {
                    if (this._dpref && this.rowsBuffer[c - 1]) {
                        this._dpref ? this._dpref : c - g;
                        var a = Math.max(0, Math.min(g, c - this._dpref));
                        this._current_load = [a, c - a];
                    }
                    else {
                        this._current_load = [g, this._dpref ? this._dpref : c - g];
                    }
                    if (this.callEvent("onDynXLS", this._current_load)) {
                        this.load(this.xmlFileUrl +
                            dhtmlx.url(this.xmlFileUrl) +
                            "posStart=" +
                            this._current_load[0] +
                            "&count=" +
                            this._current_load[1], this._data_type);
                    }
                }
                return;
            }
            else {
                if (this._tgle) {
                    this._updateLine(this._h2.get[this.rowsBuffer[g].idd], this.rowsBuffer[g]);
                    this._updateParentLine(this._h2.get[this.rowsBuffer[g].idd], this.rowsBuffer[g]);
                }
                if (g && g == (this._realfake ? this._fake : this)["_r_select"]) {
                    this.selectCell(g, this.cell ? this.cell._cellIndex : 0, true);
                }
            }
        }
    }
    if (this._fake && !this._realfake && this.multiLine) {
        this._fake.objBox.scrollTop = this.objBox.scrollTop;
    }
};
dhtmlXGridObject.prototype._add_from_buffer = function (g) {
    var h = this.render_row(g);
    if (h == -1) {
        return -1;
    }
    if (h._attrs.selected || h._attrs.select) {
        this.selectRow(h, false, true);
        h._attrs.selected = h._attrs.select = null;
    }
    if (!this._cssSP) {
        if (this._cssEven && g % 2 == 0) {
            h.className =
                this._cssEven +
                    (h.className.indexOf("rowselected") != -1 ? " rowselected " : " ") +
                    (h._css || "");
        }
        else {
            if (this._cssUnEven && g % 2 == 1) {
                h.className =
                    this._cssUnEven +
                        (h.className.indexOf("rowselected") != -1 ? " rowselected " : " ") +
                        (h._css || "");
            }
        }
    }
    else {
        if (this._h2) {
            var a = this._h2.get[h.idd];
            h.className +=
                " " +
                    (a.level % 2
                        ? this._cssUnEven + " " + this._cssUnEven
                        : this._cssEven + " " + this._cssEven) +
                    "_" +
                    a.level +
                    (this.rowsAr[a.id]._css || "");
        }
    }
    for (var c = 0; c < this._fillers.length; c++) {
        var e = this._fillers[c];
        if (e && e[0] <= g && e[0] + e[1] > g) {
            var l = g - e[0];
            if (l == 0) {
                this._insert_before(g, h, e[2]);
                this._update_fillers(c, -1, 1);
            }
            else {
                if (l == e[1] - 1) {
                    this._insert_after(g, h, e[2]);
                    this._update_fillers(c, -1, 0);
                }
                else {
                    this._fillers.push(this._add_filler(g + 1, e[1] - l - 1, e[2], 1));
                    this._insert_after(g, h, e[2]);
                    this._update_fillers(c, -e[1] + l, 0);
                }
            }
            return;
        }
    }
};
dhtmlXGridObject.prototype._update_fillers = function (e, a, g) {
    var c = this._fillers[e];
    c[1] = c[1] + a;
    c[0] = c[0] + g;
    if (!c[1]) {
        this.callEvent("onRemoveFiller", [c[2]]);
        c[2].parentNode.removeChild(c[2]);
        this._fillers.splice(e, 1);
    }
    else {
        c[2].firstChild.style.height =
            parseFloat(c[2].firstChild.style.height) + a * this._srdh + "px";
        this.callEvent("onUpdateFiller", [c[2]]);
    }
};
dhtmlXGridObject.prototype._insert_before = function (c, e, a) {
    a.parentNode.insertBefore(e, a);
    this.rowsCol[c] = e;
    this.callEvent("onRowInserted", [e, null, a, "before"]);
};
dhtmlXGridObject.prototype._insert_after = function (c, e, a) {
    if (a.nextSibling) {
        a.parentNode.insertBefore(e, a.nextSibling);
    }
    else {
        a.parentNode.appendChild(e);
    }
    this.rowsCol[c] = e;
    this.callEvent("onRowInserted", [e, null, a, "after"]);
};
goingValidation.trackInput = function (e, g, c, a) {
    /**
     * 注册键盘点击事件
     */
    goingEvent(e, "keyup", function (h) {
        if (goingValidation._timer) {
            window.clearTimeout(goingValidation._timer);
            goingValidation._timer = null;
        }
        goingValidation._timer = window.setTimeout(function () {
            if (!goingValidation.checkInput(e, g)) {
                if (!c || c(e, e.value, g)) {
                    e.className += " dhtmlx_live_validation_error";
                }
            }
            else {
                e.className = e.className.replace(/[ ]*dhtmlx_live_validation_error/g, "");
                if (a) {
                    a(e, e.value, g);
                }
            }
        }, 250);
    });
};
goingValidation.checkInput = function (a, c) {
    return goingValidation.checkValue(a.value, c);
};
/**
 *
 * @param e
 * @param g
 */
goingValidation.checkValue = function (e, g) {
    if (typeof g == "string") {
        g = g.split(",");
    }
    var a = true;
    for (var c = 0; c < g.length; c++) {
        if (!this["is" + g[c]]) {
            alert("Incorrect validation rule: " + g[c]);
        }
        else {
            a = a && this["is" + g[c]](e);
        }
    }
    return a;
};
dhtmlXGridObject.prototype.enableValidation = function (c, a) {
    c = dhx4.s2b(c);
    if (c) {
        this._validators = { data: [] };
    }
    else {
        this._validators = false;
    }
    if (arguments.length > 1) {
        this._validators._live = a;
    }
    if (!this._validators._event) {
        this._validators._event = this.attachEvent("onEditCell", this.validationEvent);
    }
};
dhtmlXGridObject.prototype.setColValidators = function (a) {
    if (!this._validators) {
        this.enableValidation(true);
    }
    if (typeof a == "string") {
        a = a.split(this.delim);
    }
    this._validators.data = a;
};
dhtmlXGridObject.prototype.validationEvent = function (l, c, g, e) {
    var o = this._validators;
    if (!o) {
        return true;
    }
    var m = o.data[g] || this.cells(c, g).getAttribute("validate") || "";
    if (l == 1 && m) {
        var h = this.editor || (this._fake || {}).editor;
        if (!h) {
            return true;
        }
        h.cell.className = h.cell.className.replace(/[ ]*dhtmlx_validation_error/g, "");
        if (o._live) {
            var a = this;
            goingValidation.trackInput(h.getInput(), m, function (r, s, u) {
                return a.callEvent("onLiveValidationError", [c, g, s, r, u]);
            }, function (r, s, u) {
                return a.callEvent("onLiveValidationCorrect", [c, g, s, r, u]);
            });
        }
    }
    if (l == 2) {
        this.validateCell(c, g, m, e);
    }
    return true;
};
/**
 * 单元格值校验
 * @param id string|number 记录id
 * @param index number 单元格序号
 * @param rule function 校验规则
 * @param g
 *
 * //when a cell doesn't have any validators assigned
 mygrid.validateCell(1,1,dhtmlxValidation.isValidTime);
 //or
 dhtmlxValidation.isMin4=function(data){
    return data.length>=4;    // the length of data should be more than 4 symbols
};
 mygrid.validateCell(1,1,dhtmlxValidation.isMin4);
 */
dhtmlXGridObject.prototype.validateCell = function (id, index, rule, g) {
    rule = rule || (this._validators.data[index] || this.cells(id, index).getAttribute("validate"));
    g = g || this.cells(id, index).getValue();
    //不存在校验规则  则直接返回了
    if (!rule) {
        return;
    }
    var cellObj = this.cells(id, index).cell;
    var a = true;
    if (typeof rule == "string") {
        rule = rule.split(this.delim);
    }
    for (var e = 0; e < rule.length; e++) {
        //如果校验不通过  则添加不通过的校验错误信息
        if (!goingValidation.checkValue(g, rule[e])) {
            if (this.callEvent("onValidationError", [id, index, g, rule[e]])) {
                cellObj.className += " dhtmlx_validation_error";
            }
            a = false;
        }
    }
    if (a) {
        //触发校验正确的事件
        this.callEvent("onValidationCorrect", [id, index, g, rule]);
        cellObj.className = cellObj.className.replace(/[ ]*dhtmlx_validation_error/g, "");
    }
    return a;
};
dhtmlXGridObject.prototype.setSubTree = function (a, c) {
    if (!this._sub_trees) {
        this._sub_trees = [];
    }
    this._sub_trees[c] = [a];
    a.parentObject.style.display = "none";
    var e = this;
    a.parentObject.onclick = function (g) {
        (g || window.event).cancelBubble = true;
        return false;
    };
    a.ev_onDblClick = null;
    a.attachEvent("onDblClick", function (g) {
        e._sub_id = g;
        e.editStop();
        return true;
    });
    a._chRRS = true;
};
dhtmlXGridObject.prototype.setSubGrid = function (c, a, g) {
    if (!this._sub_grids) {
        this._sub_grids = [];
    }
    this._sub_grids[a] = [c, g];
    c.entBox.style.display = "none";
    var e = this;
    c.entBox.onclick = function (h) {
        (h || window.event).cancelBubble = true;
        return false;
    };
    c.attachEvent("onRowSelect", function (h) {
        e.editStop();
        return true;
    });
    c._chRRS = false;
};
dhtmlXGridObject.prototype.resetCounter = function (c) {
    if (this._fake && !this._realfake && c < this._fake._cCount) {
        this._fake.resetCounter(c, this.currentPage);
    }
    var a = arguments[0] || 0;
    if (this.currentPage) {
        a = (this.currentPage - 1) * this.rowsBufferOutSize;
    }
    for (a = 0; a < this.rowsBuffer.length; a++) {
        if (this.rowsBuffer[a] &&
            this.rowsBuffer[a].tagName == "TR" &&
            this.rowsAr[this.rowsBuffer[a].idd]) {
            this.rowsAr[this.rowsBuffer[a].idd].childNodes[c].innerHTML = a + 1;
        }
    }
};
dhtmlXGridObject.prototype.setSubContext = function (a, c, g) {
    var e = this;
    a.attachEvent("onClick", function (l) {
        e._sub_id = l;
        e.editStop();
        a.hideContextMenu();
        return true;
    });
    if (!this._sub_context) {
        this._sub_context = [];
    }
    this._sub_context[c] = [a, g];
    a.hideContextMenu();
};
dhtmlXGridObject.prototype._process_html = function (c) {
    if (c.tagName && c.tagName == "TABLE") {
        return this._process_inner_html(c, 0);
    }
    var a = document.createElement("DIV");
    a.innerHTML = c.xmlDoc.responseText;
    var e = a.getElementsByTagName("TABLE")[0];
    this._process_inner_html(e, 0);
};
dhtmlXGridObject.prototype._process_inner_html = function (e, h) {
    var c = e.rows.length;
    for (var a = h; a < c; a++) {
        var g = e.rows[a].getAttribute("id") || a;
        this.rowsBuffer.push({
            idd: g,
            data: e.rows[a],
            _parser: this._process_html_row,
            _locator: this._get_html_data
        });
    }
    this.render_dataset();
    this.setSizes();
};
dhtmlXGridObject.prototype._process_html_row = function (n, h) {
    var m = h.getElementsByTagName("TD");
    var c = [];
    n._attrs = this._xml_attrs(h);
    for (var g = 0; g < m.length; g++) {
        var l = m[g];
        var a = l.getAttribute("type");
        if (n.childNodes[g]) {
            if (a) {
                n.childNodes[g]._cellType = a;
            }
            n.childNodes[g]._attrs = this._xml_attrs(m[g]);
        }
        if (l.firstChild) {
            c.push(l.innerHTML);
        }
        else {
            c.push("");
        }
        if (l.colSpan > 1) {
            n.childNodes[g]._attrs.colspan = l.colSpan;
            for (var e = 1; e < l.colSpan; e++) {
                c.push("");
            }
        }
    }
    for (g < m.length; g < n.childNodes.length; g++) {
        n.childNodes[g]._attrs = {};
    }
    this._fillRow(n, this._c_order ? this._swapColumns(c) : c);
    return n;
};
dhtmlXGridObject.prototype._get_html_data = function (c, a) {
    c = c.firstChild;
    while (true) {
        if (!c) {
            return "";
        }
        if (c.tagName == "TD") {
            a--;
        }
        if (a < 0) {
            break;
        }
        c = c.nextSibling;
    }
    return c.firstChild ? c.firstChild.data : "";
};
goingEvent(window, "load", function () {
    var e = document.getElementsByTagName("table");
    for (var c = 0; c < e.length; c++) {
        if (e[c].className == "dhtmlxGrid") {
            dhtmlXGridFromTable(e[c]);
        }
    }
});
dhtmlXGridObject.prototype._process_xmlA = function (a) {
    this._parsing = true;
    var l = dhx4.ajax.xmltop(this.xml.top, a);
    this._parseHead(l);
    var h = dhx4.ajax.xpath(this.xml.row, l);
    var g = parseInt(l.getAttribute("pos") || 0);
    var e = parseInt(l.getAttribute("total_count") || 0);
    if (e && !this.rowsBuffer[e - 1]) {
        this.rowsBuffer[e - 1] = null;
    }
    if (this.isTreeGrid()) {
        this._get_xml_data = this._get_xml_dataA;
        this._process_xml_row = this._process_xml_rowA;
        return this._process_tree_xml(a);
    }
    for (var c = 0; c < h.length; c++) {
        if (this.rowsBuffer[c + g]) {
            continue;
        }
        var m = h[c].getAttribute("id") || this.uid();
        this.rowsBuffer[c + g] = {
            idd: m,
            data: h[c],
            _parser: this._process_xml_rowA,
            _locator: this._get_xml_dataA
        };
        this.rowsAr[m] = h[c];
    }
    this.render_dataset();
    this._parsing = false;
};
dhtmlXGridObject.prototype._process_xmlB = function (a) {
    this._parsing = true;
    var l = dhx4.ajax.xmltop(this.xml.top, a);
    this._parseHead(l);
    var h = dhx4.ajax.xpath(this.xml.row, l);
    var g = parseInt(l.getAttribute("pos") || 0);
    var e = parseInt(l.getAttribute("total_count") || 0);
    if (e && !this.rowsBuffer[e - 1]) {
        this.rowsBuffer[e - 1] = null;
    }
    if (this.isTreeGrid()) {
        this._get_xml_data = this._get_xml_dataB;
        this._process_xml_row = this._process_xml_rowB;
        return this._process_tree_xml(a);
    }
    for (var c = 0; c < h.length; c++) {
        if (this.rowsBuffer[c + g]) {
            continue;
        }
        var m = h[c].getAttribute("id") || this.uid();
        this.rowsBuffer[c + g] = {
            idd: m,
            data: h[c],
            _parser: this._process_xml_rowB,
            _locator: this._get_xml_dataB
        };
        this.rowsAr[m] = h[c];
    }
    this.render_dataset();
    this._parsing = false;
};
dhtmlXGridObject.prototype._process_xml_rowA = function (h, e) {
    var a = [];
    h._attrs = this._xml_attrs(e);
    for (var c = 0; c < this.columnIds.length; c++) {
        var l = this.columnIds[c];
        var g = h._attrs[l] || "";
        if (h.childNodes[c]) {
            h.childNodes[c]._attrs = {};
        }
        a.push(g);
    }
    this._fillRow(h, this._c_order ? this._swapColumns(a) : a);
    return h;
};
dhtmlXGridObject.prototype._get_xml_dataA = function (c, a) {
    return c.getAttribute(this.getColumnId(a));
};
dhtmlXGridObject.prototype._process_xml_rowB = function (a, h) {
    var n = [];
    a._attrs = this._xml_attrs(h);
    if (this._ud_enabled) {
        var o = dhx4.ajax.xpath("./userdata", h);
        for (var e = o.length - 1; e >= 0; e--) {
            this.setUserData(o[e].getAttribute("name"), o[e].firstChild ? o[e].firstChild.data : "");
        }
    }
    for (var m = 0; m < h.childNodes.length; m++) {
        var g = h.childNodes[m];
        if (!g.tagName) {
            continue;
        }
        var c = this.getColIndexById(g.tagName);
        if (isNaN(c)) {
            continue;
        }
        var l = g.getAttribute("type");
        if (l) {
            a.childNodes[c]._cellType = l;
        }
        a.childNodes[c]._attrs = this._xml_attrs(g);
        if (!g.getAttribute("xmlcontent")) {
            if (g.firstChild) {
                g = g.firstChild.data;
            }
            else {
                g = "";
            }
        }
        n[c] = g;
    }
    for (var e_1 = 0; e_1 < a.childNodes.length; e_1++) {
        if (!a.childNodes[e_1]._attrs) {
            a.childNodes[e_1]._attrs = {};
        }
    }
    this._fillRow(a, n);
    return a;
};
dhtmlXGridObject.prototype._get_xml_dataB = function (c, a) {
    var e = this.getColumnId(a);
    c = c.firstChild;
    while (true) {
        if (!c) {
            return "";
        }
        if (c.tagName == e) {
            return c.firstChild ? c.firstChild.data : "";
        }
        c = c.nextSibling;
    }
};
dhtmlXGridObject.prototype.startFastOperations = function () {
    this._disF = [
        "setSizes",
        "callEvent",
        "_fixAlterCss",
        "cells4",
        "forEachRow",
        "_correctMonolite"
    ];
    this._disA = [];
    for (var a = this._disF.length - 1; a >= 0; a--) {
        this._disA[a] = this[this._disF[a]];
        this[this._disF[a]] = function () {
            return true;
        };
    }
    this._cellCache = [];
    this.cells4 = function (e) {
        var g = this._cellCache[e._cellIndex];
        if (!g) {
            g = this._cellCache[e._cellIndex] = this._disA[3].apply(this, [e]);
            g.destructor = function () {
                return true;
            };
            g.setCValue = function (c) {
                g.cell.innerHTML = c;
            };
        }
        g.cell = e;
        g.combo = e._combo || this.combos[e._cellIndex];
        return g;
    };
};
dhtmlXGridObject.prototype.stopFastOperations = function () {
    if (!this._disF) {
        return;
    }
    for (var a = this._disF.length - 1; a >= 0; a--) {
        this[this._disF[a]] = this._disA[a];
    }
    if (this._correctMonolite) {
        this._correctMonolite();
    }
    this.setSizes();
    this.callEvent("onGridReconstructed", []);
};
dhtmlXGridObject.prototype._in_header_number_filter = function (e, c) {
    this._in_header_text_filter.call(this, e, c);
    var a = this;
    e.firstChild._filter = function () {
        var g = a._get_filters(this.value, "num");
        return function (m) {
            var h = g.length > 0 ? false : true;
            for (var l = 0; l < g.length; l++) {
                h = h || g[l](m);
            }
            return h;
        };
    };
};
dhtmlXGridObject.prototype._in_header_string_filter = function (e, c) {
    this._in_header_text_filter.call(this, e, c);
    var a = this;
    e.firstChild._filter = function () {
        var g = a._get_filters(this.value, "str");
        return function (m) {
            var h = g.length > 0 ? false : true;
            for (var l = 0; l < g.length; l++) {
                h = h || g[l](m);
            }
            return h;
        };
    };
};
dhtmlXGridObject.prototype._get_filters = function (l, e) {
    var a = l.split(",");
    var g = [];
    for (var c = 0; c < a.length; c++) {
        if (a[c] == "") {
            continue;
        }
        var h = this["_get_" + e + "_filter"](a[c]);
        g.push(h);
    }
    return g;
};
dhtmlXGridObject.prototype._get_str_filter = function (c) {
    if (c == "null" || c == "empty") {
        return new Function("value", 'if (value == null || value == "") return true; return false;');
    }
    if (c == "!null" || c == "!empty") {
        return new Function("value", 'if (value == null || value == "") return false; return true;');
    }
    var a = null;
    if (c.substr(0, 1) === "!") {
        a = c.substr(1);
        return new Function("value", 'if (value !== "' + a + '") return true; return false;');
    }
    if (c.substr(0, 1) === "~") {
        a = c.substr(1);
        return new Function("value", 'if (value.indexOf("' + a + '") !== -1) return true; return false;');
    }
    if (c.substr(0, 1) === "^" && c.substr(c.length - 1, 1) === "&") {
        c = "=" + c.substr(1, c.length - 2);
    }
    if (c.substr(0, 1) === "^") {
        a = c.substr(1);
        return new Function("value", "if (value.substr(0, " +
            a.length +
            ') === "' +
            a +
            '") return true; return false;');
    }
    if (c.substr(c.length - 1, 1) === "&") {
        a = c.substr(0, c.length - 1);
        return new Function("value", "if (value.substr(value.length - " +
            a.length +
            ') === "' +
            a +
            '") return true; return false;');
    }
    if (c.substr(0, 1) === "=") {
        a = c.substr(1);
    }
    else {
        a = c;
    }
    return new Function("value", 'if (value === "' + a + '") return true; return false;');
};
dhtmlXGridObject.prototype._get_num_filter = function (h) {
    if (h == "null" || h == "empty") {
        return new Function("value", 'if (value == null || value == "") return true; return false;');
    }
    if (h == "!null" || h == "!empty") {
        return new Function("value", 'if (value == null || value == "") return false; return true;');
    }
    var a = h.split("..");
    if (a.length == 2) {
        var l = parseFloat(a[0]);
        var g = parseFloat(a[1]);
        return new Function("value", "if (value >= " + l + " && value <= " + g + ") return true; return false;");
    }
    var e = h.match(/<>|>=|<=|>|<|=/);
    var m = null;
    if (e) {
        m = e[0];
        var c = parseFloat(h.replace(m, ""));
    }
    else {
        m = "==";
        c = parseFloat(h);
    }
    if (m == "<>") {
        m = "!=";
    }
    if (m == "=") {
        m = "==";
    }
    return new Function("value", " if (value " + m + " " + c + " ) return true; return false;");
};
dhtmlXGridObject.prototype.attachHeaderA = dhtmlXGridObject.prototype.attachHeader;
dhtmlXGridObject.prototype.attachHeader = function () {
    this.attachHeaderA.apply(this, arguments);
    if (this._realfake) {
        return true;
    }
    this.formAutoSubmit();
    if (typeof this.FormSubmitOnlyChanged == "undefined") {
        this.submitOnlyChanged(true);
    }
    if (typeof this._submitAR == "undefined") {
        this.submitAddedRows(true);
    }
    var a = this;
    this._added_rows = [];
    this._deleted_rows = [];
    this.attachEvent("onRowAdded", function (c) {
        a._added_rows.push(c);
        a.forEachCell(c, function (e) {
            e.cell.wasChanged = true;
        });
        return true;
    });
    this.attachEvent("onBeforeRowDeleted", function (c) {
        a._deleted_rows.push(c);
        return true;
    });
    this.attachHeader = this.attachHeaderA;
};
dhtmlXGridObject.prototype.formAutoSubmit = function () {
    this.parentForm = this.detectParentFormPresent();
    if (this.parentForm === false) {
        return false;
    }
    if (this.formEventAttached) {
        return;
    }
    this.formInputs = new Array();
    var a = this;
    goingEvent(this.parentForm, "submit", function () {
        if (a.entBox) {
            a.parentFormOnSubmit();
        }
    });
    this.formEventAttached = true;
};
dhtmlXGridObject.prototype.parentFormOnSubmit = function () {
    this.formCreateInputCollection();
    if (!this.callEvent("onBeforeFormSubmit", [])) {
        return false;
    }
};
dhtmlXGridObject.prototype.submitOnlyChanged = function (a) {
    this.FormSubmitOnlyChanged = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.submitColumns = function (a) {
    if (typeof a == "string") {
        a = a.split(this.delim);
    }
    this._submit_cols = a;
};
dhtmlXGridObject.prototype.setFieldName = function (a) {
    a = a.replace(/\{GRID_ID\}/g, "'+a1+'");
    a = a.replace(/\{ROW_ID\}/g, "'+a2+'");
    a = a.replace(/\{ROW_INDEX\}/g, "'+this.getRowIndex(a2)+'");
    a = a.replace(/\{COLUMN_INDEX\}/g, "'+a3+'");
    a = a.replace(/\{COLUMN_ID\}/g, "'+this.getColumnId(a3)+'");
    this._input_mask = Function("a1", "a2", "a3", "return '" + a + "';");
};
dhtmlXGridObject.prototype.submitSerialization = function (a) {
    this.FormSubmitSerialization = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.submitAddedRows = function (a) {
    this._submitAR = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.submitOnlySelected = function (a) {
    this.FormSubmitOnlySelected = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.submitOnlyRowID = function (a) {
    this.FormSubmitOnlyRowID = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.createFormInput = function (c, e) {
    var a = document.createElement("input");
    a.type = "hidden";
    if (this._input_mask && typeof c != "string") {
        a.name = this._input_mask.apply(this, c);
    }
    else {
        a.name = ((this.globalBox || this.entBox).id || "dhtmlXGrid") + "_" + c;
    }
    a.value = e;
    this.parentForm.appendChild(a);
    this.formInputs.push(a);
};
dhtmlXGridObject.prototype.createFormInputRow = function (e) {
    var g = (this.globalBox || this.entBox).id;
    for (var c = 0; c < this._cCount; c++) {
        var a = this.cells3(e, c);
        if ((!this.FormSubmitOnlyChanged || a.wasChanged()) &&
            (!this._submit_cols || this._submit_cols[c])) {
            this.createFormInput(this._input_mask ? [g, e.idd, c] : e.idd + "_" + c, a.getValue());
        }
    }
};
dhtmlXGridObject.prototype.formCreateInputCollection = function () {
    if (this.parentForm == false) {
        return false;
    }
    for (var a = 0; a < this.formInputs.length; a++) {
        this.parentForm.removeChild(this.formInputs[a]);
    }
    this.formInputs = new Array();
    if (this.FormSubmitSerialization) {
        this.createFormInput("serialized", this.serialize());
    }
    else {
        if (this.FormSubmitOnlySelected) {
            if (this.FormSubmitOnlyRowID) {
                this.createFormInput("selected", this.getSelectedId());
            }
            else {
                for (var a_1 = 0; a_1 < this.selectedRows.length; a_1++) {
                    this.createFormInputRow(this.selectedRows[a_1]);
                }
            }
        }
        else {
            if (this._submitAR) {
                if (this._added_rows.length) {
                    this.createFormInput("rowsadded", this._added_rows.join(","));
                }
                if (this._deleted_rows.length) {
                    this.createFormInput("rowsdeleted", this._deleted_rows.join(","));
                }
            }
            this.forEachRow(function (c) {

                if (this.getRowById(c) !== -1) {

                    this.createFormInputRow(this.rowsAr[c]);
                }
            });
        }
    }
};
dhtmlXGridObject.prototype.detectParentFormPresent = function () {
    var a = false;
    var c = this.entBox;
    while (c && c.tagName && c != document.body) {
        if (c.tagName.toLowerCase() == "form") {
            a = c;
            break;
        }
        else {
            c = c.parentNode;
        }
    }
    return a;
};
dhtmlXGridObject.prototype.unGroup = function () {
    if (!this._groups) {
        return;
    }
    this._dndProblematic = false;
    delete this._groups;
    delete this._gIndex;
    if (this._fake) {
        this._mirror_rowsCol();
    }
    this.forEachRow(function (a) {

        this.rowsAr[a].style.display = "";
    });
    this._reset_view();
    this.callEvent("onGridReconstructed", []);
    this.callEvent("onUnGroup", []);
};
dhtmlXGridObject.prototype._mirror_rowsCol = function () {
    this._fake._groups = this._groups;
    this._fake._gIndex = this._gIndex;
    this.rowsBuffer = new dhtmlxArray();
    for (var a = 0; a < this.rowsCol.length; a++) {
        if (!this.rowsCol[a]._cntr) {
            this.rowsBuffer.push(this.rowsCol[a]);
        }
    }
    this._fake.rowsBuffer = new dhtmlxArray();
    for (var a_2 = 0; a_2 < this._fake.rowsCol.length; a_2++) {
        if (!this._fake.rowsCol[a_2]._cntr) {
            this._fake.rowsBuffer.push(this._fake.rowsCol[a_2]);
        }
    }
};
dhtmlXGridObject.prototype.groupBy = function (m, g) {
    if (this._groups) {
        this.unGroup();
    }
    this._dndProblematic = true;
    this._groups = {};
    if (!g) {
        g = ["#title"];
        for (var h = 1; h < this._cCount; h++) {
            g.push("#cspan");
        }
    }
    this._gmask = document.createElement("TR");
    this._gmask.origin = g;
    var l, e = 0;
    for (var h_1 = 0; h_1 < g.length; h_1++) {
        if (g[h_1] == "#cspan") {
            l.colSpan = (parseInt(l.colSpan) || 1) + 1;
        }
        else {
            l = document.createElement("TD");
            l._cellIndex = h_1;
            if (this._hrrar[h_1]) {
                l.style.display = "none";
            }
            l.className = "group_row";
            l.innerHTML = "&nbsp;";
            if (g[h_1] == "#title") {
                this._gmask._title = e;
            }
            else {
                l.align = this.cellAlign[h_1] || "left";
            }
            this._gmask.appendChild(l);
            if (g[h_1].indexOf("#stat") == 0) {
                this._gmask._math = true;
                l._counter = [this["_g_" + g[h_1].replace("#", "")], h_1, e];
            }
            e++;
        }
    }
    for (var c in this._groups) {
        this._groups[c] = this.undefined;
    }
    this._gIndex = m;
    if (this._fake && !this._realfake) {
        this._fake._groups = [];
        this._fake._gIndex = this._gIndex;
    }
    this._nextRow = function (o, a) {
        var n = this.rowsCol[o + a];
        if (n && (n.style.display == "none" || n._cntr)) {
            return this._nextRow(o + a, a);
        }
        return n;
    };
    if (!this.__sortRowsBG) {
        this._key_events = dhtmlx.extend({}, this._key_events);
        this._key_events.k38_0_0 = function () {
            if (this.editor && this.editor.combo) {
                this.editor.shiftPrev();
            }
            else {
                var a = this.row.rowIndex;
                if (!a) {
                    return;
                }
                var n = this._nextRow(a - 1, -1);
                if (n) {
                    this.selectCell(n, this.cell._cellIndex, true);
                }
            }
        };
        this._key_events.k13_1_0 = this._key_events.k13_0_1 = function () { };
        this._key_events.k40_0_0 = function () {
            if (this.editor && this.editor.combo) {
                this.editor.shiftNext();
            }
            else {
                var a = this.row.rowIndex;
                if (!a) {
                    return;
                }
                var n = this._nextRow(a - 1, 1);
                if (n) {
                    this.selectCell(n, this.cell._cellIndex, true);
                }
            }
        };
        this.attachEvent("onFilterStart", function () {

            if (this._groups) {

                this._groups = this.undefined;
            }
            return true;
        });
        this.attachEvent("onFilterEnd", function () {

            if (typeof this._gIndex != "undefined") {

                this.groupBy(this._gIndex, this._gmask.origin);
            }
        });
        this.sortRows_bg = this.sortRows;
        this.sortRows = function (o, n, a) {
            if (typeof this._groups == "undefined") {
                return this.sortRows_bg.apply(this, arguments);
            }
            n = n || this.fldSort[o] || "str";
            a = a || "asc";
            if (this.callEvent("onBeforeSorting", [o, n, a])) {
                if (typeof this._groups == "undefined") {
                    return true;
                }
                if (o == this._gIndex) {
                    this._sortByGroup(o, n, a);
                }
                else {
                    this._sortInGroup(o, n, a);
                }
                this.setSortImgState(true, o, a);
                if (this._fake) {
                    this._mirror_rowsCol();
                    this._fake._groups = [];
                    this._fake._reset_view();
                }
                this.setSortImgState(true, o, a);
                this.callEvent("onAfterSorting", [o, n, a]);
            }
            return false;
        };
        this.attachEvent("onClearAll", function () {

            this.unGroup();
        });
        this.attachEvent("onBeforeRowDeleted", function (o) {

            if (!this._groups) {
                return true;
            }

            if (!this.rowsAr[o]) {
                return true;
            }

            var n = this.cells(o, this._gIndex).getValue();
            if (n === "") {
                n = " ";
            }

            var a = this._groups[n];

            this._dec_group(a);
            return true;
        });
        this.attachEvent("onAfterRowDeleted", function () {
            this.updateGroups();
        });
        this.attachEvent("onCheckbox", function (o, a, n) {
            this.callEvent("onEditCell", [2, o, a, n ? 1 : 0, n ? 0 : 1]);
        });
        this.attachEvent("onXLE", this.updateGroups);
        this.attachEvent("onColumnHidden", this.hideGroupColumn);
        this.attachEvent("onEditCell", function (D, u, A, y, E) {

            if (!this._groups) {
                return true;
            }

            if (D == 2 && y != E && A == this._gIndex) {
                if (E === "") {
                    E = " ";
                }

                this._dec_group(this._groups[E]);

                var a = this.rowsAr[u];

                var C = this.rowsCol._dhx_find(a);

                var w = this._inc_group(y);

                var x = this.rowsCol[w];
                if (a == x) {
                    x = x.nextSibling;
                }
                var s = a.parentNode;
                // var v = a.rowIndex;
                s.removeChild(a);
                if (x) {
                    s.insertBefore(a, x);
                }
                else {
                    s.appendChild(a);
                }

                this.rowsCol._dhx_insertAt(w, a);
                if (w < C) {
                    C++;
                }

                this.rowsCol._dhx_removeAt(C, a);

                this._fixAlterCss();
            }
            else {
                if (D == 2 && y != E) {

                    this.updateGroups();

                    this._updateGroupView(this._groups[this.cells(u, this._gIndex).getValue() || " "]);
                }
            }
            return true;
        });
        this.__sortRowsBG = true;
    }
    this._groupExisting();
    if (this._hrrar) {
        for (var h_2 = 0; h_2 < this._hrrar.length; h_2++) {
            if (this._hrrar[h_2]) {
                this.hideGroupColumn(h_2, true);
            }
        }
    }
    this.callEvent("onGroup", []);
    if (this._ahgr || this._awdth) {
        this.setSizes();
    }
};
dhtmlXGridObject.prototype._sortInGroup = function (e, n, g) {
    var o = this._groups_get();
    o.reverse();
    for (var l = 0; l < o.length; l++) {
        var m = o[l]._cntr._childs;
        var r = {};
        for (var h = 0; h < m.length; h++) {
            var s = this.cells3(m[h], e);
            r[m[h].idd] = s.getDate ? s.getDate() : s.getValue();
        }
        this._sortCore(e, n, g, r, m);
    }
    this._groups_put(o);
    this.setSizes();
    this.callEvent("onGridReconstructed", []);
};
dhtmlXGridObject.prototype._sortByGroup = function (h, m, e) {
    var c = this._groups_get();
    var g = [];
    for (var l = 0; l < c.length; l++) {
        c[l].idd = "_sort_" + l;
        g["_sort_" + l] = c[l]._cntr.text;
    }
    this._sortCore(h, m, e, g, c);
    this._groups_put(c);
    this.callEvent("onGridReconstructed", []);
    this.setSizes();
};
dhtmlXGridObject.prototype._inc_group = function (h, e, a) {
    if (h === "") {
        h = " ";
    }
    if (!this._groups[h]) {
        this._groups[h] = {
            text: h,
            row: this._addPseudoRow(),
            count: 0,
            state: e ? "plus" : "minus"
        };
    }
    var g = this._groups[h];
    g.row._cntr = g;
    var c = this.rowsCol._dhx_find(g.row) + g.count + 1;
    g.count++;
    if (!a) {
        this._updateGroupView(g);
        this.updateGroups();
    }
    return c;
};
dhtmlXGridObject.prototype._dec_group = function (a) {
    if (!a) {
        return;
    }
    a.count--;
    if (a.count == 0) {
        a.row.parentNode.removeChild(a.row);
        this.rowsCol._dhx_removeAt(this.rowsCol._dhx_find(a.row));
        delete this._groups[a.text];
    }
    else {
        this._updateGroupView(a);
    }
    if (this._fake && !this._realfake) {
        this._fake._dec_group(this._fake._groups[a.text]);
    }
    this.updateGroups();
    return true;
};
dhtmlXGridObject.prototype._insertRowAt_gA = dhtmlXGridObject.prototype._insertRowAt;
dhtmlXGridObject.prototype._insertRowAt = function (e, g, c) {
    var h = null;
    if (typeof this._groups != "undefined") {
        if (this._realfake) {
            h = this._fake._bfs_cells(e.idd, this._gIndex).getValue();
        }
        else {
            if (this._bfs_cells3) {
                h = this._bfs_cells3(e, this._gIndex).getValue();
            }
            else {
                h = this.cells3(e, this._gIndex).getValue();
            }
        }
        if (!h) {
            h = " ";
        }
        g = this._inc_group(h, e.style.display == "none");
    }
    var a = this._insertRowAt_gA(e, g, c);
    if (typeof this._groups != "undefined") {
        this.expandGroup(h);
        this._updateGroupView(this._groups[h]);
        this.updateGroups();
    }
    return a;
};
dhtmlXGridObject.prototype._updateGroupView = function (e) {
    if (this._fake && !this._realfake) {
        return (e.row.firstChild.innerHTML = "&nbsp;");
    }
    var a = this._gmask || this._fake._gmask;
    var c = "<img style='margin-bottom:-4px' src='" + this.imgURL + e.state + ".gif'> ";
    if (this.customGroupFormat) {
        c += this.customGroupFormat(e.text, e.count);
    }
    else {
        c += e.text + " ( " + e.count + " ) ";
    }
    e.row.childNodes[a._title].innerHTML = c;
};
dhtmlXGridObject.prototype._addPseudoRow = function (h) {
    var a = this._gmask || this._fake._gmask;
    var g = a.cloneNode(true);
    for (var c = 0; c < g.childNodes.length; c++) {
        g.childNodes[c]._cellIndex = a.childNodes[c]._cellIndex;
        if (this._realfake) {
            g.childNodes[c].style.display = "";
        }
    }
    var e = this;
    g.onclick = function (l) {
        if (!e.callEvent("onGroupClick", [this._cntr.text])) {
            return;
        }
        if (e._fake && e._realfake) {
            e._fake._switchGroupState(e._fake._groups[this._cntr.text].row);
        }
        else {
            e._switchGroupState(this);
        }
        (l || event).cancelBubble = "true";
    };
    g.ondblclick = function (l) {
        (l || event).cancelBubble = "true";
    };
    if (!h) {
        if (window._isKHTML) {
            this.obj.appendChild(g);
        }
        else {
            this.obj.firstChild.appendChild(g);
        }
        this.rowsCol.push(g);
    }
    return g;
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dxGridMethods0.js